import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import CustomButton from "../../../components/CustomButton";
import { useSelector } from "react-redux";
import { RootState } from "../../../store";

const PromptNoTaxableIncome = ({ show, onCancel, onContinue }: any) => {
  const other_income = useSelector((state: RootState) => {
    const irs1040 = state.tax.irs1040;
    if (irs1040 && irs1040.document_name !== 'error') {
      return Number(irs1040.form_data.other_income);
    }
    return 0;
  });

  return (
    <Modal
      disableAutoFocus
      open={show}
      onClose={() => onCancel()}
      aria-labelledby="confirm-1040-income-modal"
      className={'modal-container'}
    >
      <div className={'modal-paper'}>
        <Box component="h3" m={1} className={'modal-title'}>
          {other_income ? 'Do You Have Wage Income?' : 'Do You Need to File a Springboro Return?'}
        </Box>
        {other_income ? (
          <p>
            LIME did not find any wage income listed on line 1a of your Federal Form 1040. Please
            double check your 1040 now. If there is a number listed on line 1a, select "back" and
            use the edit tool to enter the reported wages in LIME (line 1). Otherwise, select
            “continue.”
          </p>
        ) : (
          <p>
            LIME did not find any taxable income listed on line 1a or 8 of your Federal Form 1040.
            Please double check your Federal Form 1040 now. If there is a number on line 1a OR
            line 8, select "back" and use the edit tool to enter the number(s) in LIME.
            If there are no entries on your Federal Form 1040 for either line 1(a) or 8, you have no
            Springboro taxable income and will either need to file a “No Income” return or an
            exemption form. Please contact us for further direction by:
            <ul>
              <li>Calling <strong>{import.meta.env.VITE_APP_SAAS_CUSTOMER_PHONE}</strong></li>
            </ul>
            <ul>
              <li>Emailing <a href={`mailto:${import.meta.env.VITE_APP_SAAS_CUSTOMER_EMAIL}`} className={'link'} >LIME Support</a></li>
            </ul>
          </p>
        )}

        <Box className={'modal-button-container'} sx={{ marginTop: '1em' }}
        >
          <CustomButton
            variant="outlined"
            disableElevation={false}
            label={"Back"}
            onClick={() => onCancel()}
          />
          {!!other_income && <CustomButton
            variant="contained"
            disableElevation={false}
            label={"Continue"}
            onClick={() => onContinue()}
          />}
        </Box>
      </div>
    </Modal>
  );
};

export default PromptNoTaxableIncome;
